/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Trimestre } from '@/types';

type TrimestreStoreType = {
  trimestre: Trimestre;
  setTrimestre: (parametres: Trimestre) => void;
  isCurrentTrimestreActif?: boolean;
  setIsCurrentTrimestreActif?: (isCurrentTrimestreActif: boolean) => void;
  shouldWarnUser: boolean;
  setShouldWarnUser: (shouldWarnUser: boolean) => void;
};

const useTrimestreStore = create<TrimestreStoreType>()(
  devtools((set) => ({
    trimestre: null,
    setTrimestre: (trimestre) => set({ trimestre }),
    isCurrentTrimestreActif: true,
    setIsCurrentTrimestreActif: (isCurrentTrimestreActif) =>
      set({ isCurrentTrimestreActif }),
    shouldWarnUser: true,
    setShouldWarnUser: (shouldWarnUser) => set({ shouldWarnUser }),
  })),
);

export default useTrimestreStore;
